import React from 'react'
import CV from '../../assets/PRANAV_MANGLANI_CV.pdf'

const CTA = () => {
  return (
    <div className='cta'>
        <a href={CV} download className='btn btn-header'>Download CV</a>
        <a href='#contact' className='btn btn-primary btn-header'>Let's Talk</a>
    </div>
  )
}

export default CTA